<template>
  <div id="container" class="sbook_st_list">
    <!-- Tab START -->
    <LinkTab
      :current="currentCategory"
      :tabs="categories"
      @tab-clicked="changeCategory"
    >
      <!-- Tabbed Content Areas -->
      <!-- TODO: Add filters for each row of selfbooks -->
      <div class="tab_page">
        <div
          :class="{ eplist: getSelfBooks && getSelfBooks.length > 0 }"
          class="item_columns_grid sbook"
        >
          <ul v-if="!isSelfBookLoading && getSelfBooks" class="item_list">
            <BaseSelfbook
              v-for="(selfbook, idx) in getSelfBooks"
              :key="idx"
              :selfbook="selfbook"
              mode="view"
            />
          </ul>
        </div>
      </div>

      <!-- IF NO BOOKS EXIST, SHOW THIS -->
      <div v-if="!isSelfBookLoading && !getSelfBooks" class="tab_detail">
        <!-- tab content 0 - 탭 미 활성, 해상 탭 모바일 + 태블릿에서는 제공하지 않습니다. -->
        <div class="tab_page">
          <div class="noSelfbook">
            <div class="p-2">
              {{ $t('views.selfbook.selfbook.noselfbook') }}
            </div>
            <div class="tit">
              <p class="blind">{{ $t('views.selfbook.selfbook.4646') }}</p>
            </div>
            <div class="btn_wrap">
              <router-link :to="{ name: 'selfbook_upload' }" class="box_btn">
                <span class="an_t">{{
                  $t('views.selfbook.selfbook.4763')
                }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <Pagination
        :current-page="currentPage"
        :total-count="getSelfBookTotalCount"
        :item-per-page="booksPerPage"
        @paginate="paginate"
      />
    </LinkTab>

    <!-- SWIPER AREA -->
    <!-- 인기 셀프북 START -->
    <!--
    <div class="section full">
      <div class="inner">
        <h2>
          <router-link :to="{ name: 'selfbook_create' }" class="sec_title"
            ><span>{{ $t('views.selfbook.selfbook.9214') }}</span></router-link
          >
        </h2>
        <div class="eplist item_columns_5 sbook">
          <div class="swipe_wrap">
            <div class="swipe_area">
              <div class="swipe_content">
                <ul
                  v-if="!isPopularSelfBookLoading && getPopularSelfBooks"
                  class="item_list"
                >
                  <swiper :options="swiperOptionsPopularSelfbook">
                    
                    <swiper-slide
                      v-for="(selfbook, idx) in getPopularSelfBooks"
                      :key="idx"
                    >
                      <BaseSelfbook :selfbook="selfbook" mode="view" />
                    </swiper-slide>
                  </swiper>
                </ul>
              </div>
            </div>
            <div class="swipe_nav">
              <button
                id="selfbookPopularPrev"
                type="button"
                class="svg_swipe_prew"
              >
                <span class="blind">이전</span>
              </button>
              <button
                id="selfbookPopularNext"
                type="button"
                class="svg_swipe_next"
              >
                <span class="blind">{{ $t('common.ui.next') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->
    <!-- 인기 셀프북 END -->

    <!-- SelfBook - banner -->
    <div class="section fill selfbook_banner_n1">
      <div class="inner">
        <div class="banner_wrap">
          <p>
            <span class="img_banner"></span>
            <span class="blind">{{ $t('views.selfbook.selfbook.297') }}</span>
          </p>
        </div>
      </div>
    </div>

    <!-- 헬프 데스크 START -->
    <HelpDesk />
    <!-- 헬프 데스크 END -->
  </div>
</template>

<script>
import BaseSelfbook from '@/components/base/BaseSelfbook.vue'
import HelpDesk from '@/components/common/HelpDesk.vue'
import LinkTab from '@/components/selfbook/LinkTab'
import swiperSettings from '@/data/swiperSettings'
import { mapGetters } from 'vuex'

import {
  SELFBOOK_GET_LIST //SELFBOOK_POPULAR_GET_LIST
} from '@/store/types'

export default {
  name: 'Selfbook',
  components: { LinkTab, HelpDesk, BaseSelfbook },
  data() {
    return {
      ...swiperSettings,
      booksPerPage: 10,
      currentPage: 1,
      currentCategory: 'ALL',
      categories: [
        {
          text: `${this.$t('views.selfbook.selfbook.all')}`,
          value: 'ALL'
        },
        {
          text: `${this.$t('views.selfbook.selfbook.making')}`,
          value: 'ED'
        }
        /*
        {
          text: `${this.$t('views.selfbook.selfbook.selling')}`,
          value: 'SA'
        },
        {
          text: `${this.$t('views.selfbook.selfbook.sellingstop')}`,
          value: 'SU'
        }
        */
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getSelfBooks',
      //'getPopularSelfBooks',
      'isSelfBookLoading',
      'isPopularSelfBookLoading',
      'getSelfBookTotalCount',
      'getCurrentUser'
    ])
  },
  mounted() {
    if (!this.getSelfBooks) {
      this.$store.dispatch(SELFBOOK_GET_LIST, {})
    }
    if (window.location.host == 'khu.ealice.com') {
      alert('현재 준비중인 서비스입니다.')
      this.$router.push({ name: 'store' })
    }
  },
  methods: {
    changeCategory(category) {
      this.currentCategory = category.value
      this.currentPage = 1
      this.$store.dispatch(SELFBOOK_GET_LIST, {
        category: this.currentCategory
      })
    },
    async paginate(page) {
      this.currentPage = page

      await this.$store.dispatch(SELFBOOK_GET_LIST, {
        page: this.currentPage,
        category: this.currentCategory
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.noSelfbook {
  font-family: Gmarket Sans TTF;
  padding: 25px 25px 50px;
  font-weight: bold;
  font-size: 25px;
  line-height: normal;
  text-align: center;
}

@media (min-width: 850px) {
  .noSelfbook {
    padding: 25px 25px 50px;
    font-size: 52px;
  }
}
</style>
